
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
[hidden] {
  display: none !important;
}
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.se-featured-content-card__wrapper{
    width:100%;
    display:flex;
    flex-direction:column;
    height:100%;
    justify-content:center;
    row-gap:1.25rem;
  }
  .se-featured-content-card__title{
    color:var(--brand-primary-1);
  }
  .se-featured-content-card__content{
    margin:0;
    font-size:var(--fs-lg-mobile);
    color:var(--brand-neutral-gray-800);
  }
  @media (min-width: 768px){
  .se-featured-content-card__content{
      font-size:var(--fs-lg)
  }
    }
`;